import React from 'react'

// Vendor
import { useTranslation } from 'react-i18next'

// Reactor UI
import { Flex, Box } from 'reactor-ui'
import Icon from 'reactor-ui/components/Icon'
import Alert from 'reactor-ui/components/Alert'
import Button from 'reactor-ui/components/Button'
import Portal from 'reactor-ui/components/Portal'
import { HStack } from 'reactor-ui/components/Stack'
import { Menu, MenuButton, MenuList, MenuItem, useDisclosure } from 'reactor-ui/components/Menu'

// Reactor
import useReactorQuery from 'reactor/hooks/useReactorQuery'
import ReactorAction from './ReactorAction'

import QueryLoading from 'reactor-vera/apps/ui/components/QueryLoading'


const ActionGroup = ({
  name, contexts, kinds, ctx, renderer, callbacks, ready = true, isMultiple = false, renderAsMenu = false,
  iconOnly = false
}) => {
  const { t } = useTranslation()
  const result = useReactorQuery({
    reactorActionGroup: {
      name,
      contexts,
      kinds,
      ctx,
      isMultiple
    }
  }, {
    ready: ready
  })

  if (result?.status?.status === 'ERROR') {
    return (
      <Alert sx={{
        width: 'auto',
        mx: 3,
        borderRadius: 4
      }}>
        {t('text.action_fetch_error')}

        <Button ml={3} size='sm' onClick={result.refresh} sx={{
          textTransform: 'capitalize',
        }}>{t('op.refresh')}</Button>
      </Alert>
    )
  }

  const actions = result?.graph?.reactorActionGroup?.actions

  let content
  if (actions) {
    if (renderer) {
      content = renderer(actions, callbacks)
    } else if (renderAsMenu || actions?.length > 4) {
      content = <ActionGroupMenu callbacks={{onSuccess: result.refresh}} actions={actions}/>
    } else {
      content = (
        <HStack wrap='wrap' justify='space-evenly' shouldWrapChildren spacing={2}>
          {actions?.map((action, dx) => <ReactorAction iconOnly={iconOnly} onSuccess={data => {
            callbacks?.onSuccess?.(data)
            result.refresh()
          }} action={action} key={dx} />)}
        </HStack>
      )
    }
  } else {
    if (renderer) {
      content = renderer(actions, callbacks)
    }
  }

  return (
    <QueryLoading result={result}>
      {content}
    </QueryLoading>
  )

}

export const ActionGroupMenu = ({
  sx,
  callbacks,
  anchor,
  actions,
  onClose,
  ...props
}) => {
  const { t } = useTranslation()
  // const { isOpen, onOpen, onClose } = useDisclosure()
  const [content, setContent] = React.useState(null)
  const [isOpen, setIsOpen] = React.useState(false)

  let rendered

  if (content) rendered = (
    // <MenuList>
    <Box p={3}>
      {content}
    </Box>
    // </MenuList>
  )
  else if (actions) {
    rendered = (
      <div>
        {actions?.map((action, dx) => {
          if (action.meta?.ui?.displayAs === 'MENU') {
            return (
              <MenuItem sx={{
                textTransform: 'capitalize'
              }} key={dx} onClick={() => setContent(
                <ReactorAction onSuccess={callbacks?.onSuccess} onClose={() => {
                  // onClose()
                  setContent(null)
                }} displayAs='FORM' action={action} />
              )}>
                {t(action.meta.ui.name)}
              </MenuItem>
            )
          }

          return (
            <ReactorAction key={dx} onClose={() => {
              // onClose()
              setContent(null)
            }} anchorKind={'MENUITEM'} action={action} onSuccess={callbacks?.onSuccess}/>
          )
        })}
        {(!actions || actions?.length === 0) && (
          <Box textAlign='center' sx={{ fontSize: 'sm' }}>
            Aksiyon yok.
          </Box>
        )}
      </div>
    )
  } else {
    rendered = (
      <ActionGroup ready={isOpen} renderer={actions => {
        return (
          <div>
            {actions?.map((action, dx) => {
              if (action.meta?.ui?.displayAs === 'MENU') {
                return (
                  <MenuItem sx={{
                    textTransform: 'capitalize'
                  }} key={dx} onClick={() => setContent(
                    <ReactorAction onSuccess={callbacks?.onSuccess} onClose={() => {
                      // onClose()
                      setContent(null)
                    }} displayAs='FORM' action={action} />
                  )}>
                    {t(action.meta.ui.name)}
                  </MenuItem>
                )
              }

              return (
                <ReactorAction key={dx} onClose={() => {
                  // onClose()
                  setContent(null)
                }} anchorKind={'MENUITEM'} action={action} onSuccess={callbacks?.onSuccess}/>
              )
            })}
            {(!actions || actions?.length === 0) && (
              <Box textAlign='center' sx={{ fontSize: 'sm' }}>
                Aksiyon yok.
              </Box>
            )}
          </div>
        )
      }} displayAs={'menuItem'} {...props} />
    )
  }

  // return (
  //   <Popover
  //   onOpen={() => setIsOpen(true)}
  //   onClose={() => setIsOpen(false)}
  //   sx={{
  //     textAlign: 'left'
  //   }}
  //   >
  //     <PopoverTrigger>
  //       <Button><Icon name='more' size={'12px'} color='brand.500' /></Button>
  //     </PopoverTrigger>
  //     <PopoverContent>
  //       <PopoverArrow />
  //       <PopoverCloseButton />
  //       <PopoverHeader>Confirmation!</PopoverHeader>
  //       <PopoverBody>
  //         {/* {isOpen && rendered} */}
  //         {rendered}
  //       </PopoverBody>
  //     </PopoverContent>
  //   </Popover>
  // )

  let button
  if (anchor) {
    button = (
      <MenuButton sx={sx}
      // onClick={onOpen}
      // rightIcon={<ChevronDownIcon />}
      >
        {anchor}
      </MenuButton>
    )
  } else {
    button = (
      <MenuButton as={Button} size='xs' sx={sx}
      // onClick={onOpen}
      // rightIcon={<ChevronDownIcon />}
      >
        <Icon name='more' size={'12px'} color='brand.500' />
      </MenuButton>
    )
  }

  return (
    <Menu
      // isLazy
      onOpen={() => setIsOpen(true)}
      onClose={() => {
        setIsOpen(false)
        setContent(null)
        onClose?.()
      }}
      // isOpen={isOpen}
      // onClose={() => {
      //   onClose()
      //   // setContent(null)
      // }}
      closeOnSelect={false}
      closeOnBlur={!content}
    >
      {({ isOpen }) => (
        <>
          {button}
          {/* {isOpen && rendered} */}
          <Portal>
            <MenuList sx={{
              maxWidth: 300
            }}>
              {rendered}
            </MenuList>
          </Portal>
        </>
      )}
    </Menu>
  )
}

export const MultipleActionGroupMenu = ({
  sx,
  callbacks,
  anchor,
  actions,
  onClose,
  ids,
  ctx,
  ...props
}) => {
  const { t } = useTranslation()
  // const { isOpen, onOpen, onClose } = useDisclosure()
  const [content, setContent] = React.useState(null)
  const [isOpen, setIsOpen] = React.useState(false)

  let rendered
  if (content) rendered = (
    // <MenuList>
    <Box p={3}>
      {content}
    </Box>
    // </MenuList>
  )
  else if (actions) {
    rendered = (
      <div>
        {actions?.map((action, dx) => {
          if (action.meta?.ui?.displayAs === 'MENU') {
            return (
              <MenuItem sx={{
                textTransform: 'capitalize'
              }} key={dx} onClick={() => setContent(
                <ReactorAction onSuccess={callbacks?.onSuccess} onClose={() => {
                  // onClose()
                  setContent(null)
                }} displayAs='FORM' action={action} />
              )}>
                {t(action.meta.ui.name)}
              </MenuItem>
            )
          }

          return (
            <ReactorAction key={dx} onClose={() => {
              // onClose()
              setContent(null)
            }} anchorKind={'MENUITEM'} action={action} />
          )
        })}
        {(!actions || actions?.length === 0) && (
          <Box textAlign='center' sx={{ fontSize: 'sm' }}>
            Aksiyon yok.
          </Box>
        )}
      </div>
    )
  } else {
    rendered = (
      <ActionGroup ctx={{...ctx, ids}} isMultiple ready={isOpen} renderer={actions => {
        return (
          <div>
            {actions?.map((action, dx) => {
              if (action.meta?.ui?.displayAs === 'MENU') {
                return (
                  <MenuItem sx={{
                    textTransform: 'capitalize'
                  }} key={dx} onClick={() => setContent(
                    <ReactorAction initialValues={{ids}} onSuccess={callbacks?.onSuccess} onClose={() => {
                      // onClose()
                      setContent(null)
                    }} displayAs='FORM' action={action} />
                  )}>
                    {t(action.meta.ui.name)}
                  </MenuItem>
                )
              }

              return (
                <ReactorAction key={dx} onClose={() => {
                  // onClose()
                  setContent(null)
                }} anchorKind={'MENUITEM'} action={action} />
              )
            })}
            {(!actions || actions?.length === 0) && (
              <Box textAlign='center' sx={{ fontSize: 'sm' }}>
                Aksiyon yok.
              </Box>
            )}
          </div>
        )
      }} displayAs={'menuItem'} {...props} />
    )
  }

  let button
  if (anchor) {
    button = (
      <MenuButton sx={sx}
      // onClick={onOpen}
      // rightIcon={<ChevronDownIcon />}
      >
        {anchor}
      </MenuButton>
    )
  } else {
    button = (
      <MenuButton as={Button} size='xs' sx={sx}
      // onClick={onOpen}
      // rightIcon={<ChevronDownIcon />}
      >
        <Icon name='more' size={'12px'} color='brand.500' />
      </MenuButton>
    )
  }

  return (
    <Menu
      // isLazy
      onOpen={() => setIsOpen(true)}
      onClose={() => {
        setIsOpen(false)
        setContent(null)
        onClose?.()
      }}
      // isOpen={isOpen}
      // onClose={() => {
      //   onClose()
      //   // setContent(null)
      // }}
      closeOnSelect={false}
      closeOnBlur={!content}
    >
      {({ isOpen }) => (
        <>
          {button}
          {/* {isOpen && rendered} */}
          <Portal>
            <MenuList sx={{
              maxWidth: 300
            }}>
              {rendered}
            </MenuList>
          </Portal>
        </>
      )}
    </Menu>
  )
}

export default ActionGroup